import React, { PureComponent } from 'react'
import { dlRowClick } from '../DataLayer';
import { getIntegerIconLabel } from '../helper/IconOptions';
import { locationValueToString } from '@touchsource/wayfinding_lib';
import { TOUCH_ACTION_DIRECT_WAYFINDING, isWayfindingModalAction } from '../util/touchActions';
import Showdown from 'showdown';

const converter = new Showdown.Converter();

class ListingRow extends PureComponent {

	constructor(props) {
		super(props)

		this.touchStartY = 0;
		this.mouseStartY = 0;

		this.state = {
			activeButton: '',
			configuration: 0,
			css: props.CSSModules["ListingRow"],
			data: ['John Smith', 'Floor A', '201'],
			messageText: "Sending...",
			modalTimeout: null,
			showMessageText: false,

			trayDetails: '',
			trayOpen: false,
		}
	}

	trayDetails = () => {
		let details = '';
		if (this.props.currentDetailAction === 1 && this.state.trayOpen === true) {
			details = this.state.trayDetails;
		}
		return details;
	}

	isTime(time) {
		if (time.match(/^([0-1][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/g)) {
			return true
		}
		return false
	}

	isValidDate(date) {
		// Checks if the value string is a date in ISO 8601 format"
		// YYYY-MM-DDTHH:MM:SSZ
		const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;

		return iso8601Regex.test(date);
	}

	convertMilitaryToCivilianTime(militaryTime) {
		const timeArray = militaryTime.split(":");
		let hour = parseInt(timeArray[0], 10);
		const minute = timeArray[1];
		let period = "AM";

		if (hour === 0) {
			hour = 12;
		} else if (hour === 12) {
			period = "PM"
		} else if (hour > 12) {
			hour -= 12;
			period = "PM";
		}

		// Pad with leading zeros if needed
		const paddedMinute = minute.padStart(2, '0');

		return `${hour}:${paddedMinute} ${period}`;
	}

	handleDown = (buttonId, msg) => {
		// console.log(`Event ${msg} handleDown() activeButton:${buttonId}`);
		this.setState({activeButton: buttonId})
	}

	handleUp = (msg) => {
		// console.log(`Event ${msg} handleUp() activeButton:''`);
		if (this.state.activeButton !== '') {
			this.setState({activeButton: ''});
		}
	}

	sendMessage = (formattedData, type) => {
		// In-flight guard: a double-tap must not POST the message twice (DEV-12143)
		if (this.messageSendInFlight) {
			return;
		}

		// Built before the guard is raised, so a synchronous throw here (_getEnv
		// not yet injected by rooster) leaves the guard untouched.
		const url = `${window._getEnv('BRONCO_URL')}/vc`;

		const body = {
			'messageID': formattedData.messageID,
			'contact': formattedData.contact,
			'type':	   type,
		}

		this.messageSendInFlight = true;

		// fetch() is invoked inside the chain so that a synchronous throw (no
		// fetch in the environment, bad URL) becomes a rejection and .finally
		// still runs. If it escaped instead, the guard would latch true and this
		// row's message buttons would be dead for the life of the instance.
		Promise.resolve()
		.then(() => fetch(url, {
			body: JSON.stringify(body),
			headers: { 'Content-Type': 'application/json' },
			method: 'POST'
		}))
		.then((response) => {
			if (response.ok || response.status === 200 || response.status === 201) { // Check if status is 200 or 201
				this.setState({ messageText: "Your message has been sent." });
        	} else {
            	throw new Error('Non-success response status'); // Throw an error for non-200/201 statuses
        	}
        	return response.json();
		})
		.catch((err) => {
			this.setState({ messageText: "Message failed to send."});
			console.error(err);

		})
		.finally(() => {
			this.messageSendInFlight = false;
		});
		this.handleMessageClick();
	}

	getDataFromMessagingOptions = (data) => {
		const { detailsGrp } = this.props;

		let label;
		let contact = '';
		for (let detail of detailsGrp) {
			if (detail.column_uuid === data.column_uuid && detail.value) {
				label = detail.label;
		
				try {
					if (detail.type === "SMS Message") {
						let jsonPhoneData = JSON.parse(detail.value);
						contact = `+1${jsonPhoneData.area}-${jsonPhoneData.n}`.replace(/-/g, '');;
					} else if (detail.type === "Email Message") {
						// debugger
						let jsonEmailData = JSON.parse(detail.value);
						contact = `${jsonEmailData.email}@${jsonEmailData.domain}`;
					} else {
						contact = detail.value;
					}
				} catch (err) {
					console.log("Failed parsing detail.value", err);
				}
			}
		}
		
		return[contact, label] ;
	}
	

	createData = () => {
		let css = this.state.css;
		let rowCss = this.props.css;
		let rowUUID = this.props.rowUUID;
		let currentDetailAction = this.props.currentDetailAction;
		let messageLabels = this.props.messageLabels

		let rowIconClasses = `${css.rowIcon} rowIcon`;
		if (currentDetailAction === 7 || currentDetailAction === TOUCH_ACTION_DIRECT_WAYFINDING) {
			rowIconClasses += ` ${css.wayfindingIcon}`
		}
		if (currentDetailAction === 13) { 
			rowIconClasses += ` ${css.videoIcon}`
		}

		let row = [];
		let imageTypeData = []; // To store image-type data		
		let stringTypeData = []; // To store string-type data
		let boxListingImageData = []; // To store box listing image data

		
		if (this.props.currentDetailAction !== 0 && !this.props.boxStyleDisplay) {
			row.push(<div className={rowIconClasses} key={`icon_${rowUUID}`}></div>);
		}
		this.props.data.forEach((data, i) => {
			// console.log("data", data)			
			let formattedData = data.value
			switch (data.type) {
				case 'time':
					if (data.value) {
						formattedData = this.convertMilitaryToCivilianTime(data.value);
					}
					break;
				case 'datetime':
					if (data.value) {
						let unixDate = Date.parse(data.value);
						let date = new Date(unixDate);
						formattedData = date.toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" });
					}
					break;
				case 'int':
					if (data.displayName === 'Directional Arrows') {
						formattedData = getIntegerIconLabel(data.displayName, data.value)
					}
					break;
				default:
					break;
			}

			if (data.displayName === 'Location (apt/suite)' && data.value) {
				formattedData = locationValueToString(data.value);
			}

			if (data.displayName === 'SMS Message' || data.displayName === 'Email Message' || data.displayName === 'Teams' || data.displayName === 'Slack') {				
				let [contact, label] = this.getDataFromMessagingOptions(data);
				formattedData = { messageID: messageLabels[label]?.messageID, contact: contact, label: messageLabels[label]?.messageButtonLabel };
			}

			if (!this.props.boxStyleDisplay) {
				let lineCss = {
					width: '0%'
				}
				if (typeof this.props.css !== 'undefined') {
					lineCss = {
						width: rowCss[i] + '%',
					}
				}

				if (this.props.textAlign) {
					lineCss = {
						...lineCss, 
						textAlign: this.props.textAlign[i],
					}
				}

				if (data.displayName === 'Directional Arrows') {
					lineCss = {
						...lineCss, 
						display: 'flex',
    					justifyContent: this.props.textAlign[i],
					}
				}
					
					if (lineCss.width !== '0%') {
						switch (data.displayName) {
							case 'SMS Message':
								if (formattedData.label) {
									stringTypeData.push(
										<div
											className={`${css.rowData} ${css[`rowData_${i}`]} rowData rowData_${i} ${css.msgBtnCont} msgBtnCont`}
											style={lineCss}
											data-key={`button_${i}_${rowUUID}`}
											key={`button_${i}_${rowUUID}`}
										>
										<button
											className={`${css.rowData} rowData_${i} ${css.msgBtn} msgBtn`}
											onMouseDown={(event) => event.stopPropagation()}
											onMouseUp={(event) => event.stopPropagation()}
											onTouchStart={(event) => event.stopPropagation()}
											onTouchEnd={(event) => event.stopPropagation()}
											onClick={(event) => {
												event.stopPropagation();
												this.sendMessage(formattedData, 'sms');
											}}>
											{formattedData.label}
										</button>
										</div>
									)
								} else {
									// If empty label, create empty div for formatting purposes
									stringTypeData.push(
										<div
												className={`${css.rowData} ${css[`rowData_${i}`]} rowData rowData_${i}`}
												style={lineCss}
												data-key={`button_${i}_${rowUUID}`}
												key={`button_${i}_${rowUUID}`}
											>
										</div>
									)
								}
								break;
							case 'Email Message':
								if (formattedData.label) {
									stringTypeData.push(
										<div
											className={`${css.rowData} ${css[`rowData_${i}`]} rowData rowData_${i} ${css.msgBtnCont} msgBtnCont`}
											style={lineCss}
											data-key={`button_${i}_${rowUUID}`}
											key={`button_${i}_${rowUUID}`}
										>
										<button
											className={`${css.rowData} rowData_${i} ${css.msgBtn} msgBtn`}
											onMouseDown={(event) => event.stopPropagation()}
											onMouseUp={(event) => event.stopPropagation()}
											onTouchStart={(event) => event.stopPropagation()}
											onTouchEnd={(event) => event.stopPropagation()}
											onClick={(event) => {
												event.stopPropagation();
												this.sendMessage(formattedData, 'email');
											}}>
											{formattedData.label}
										</button>
										</div>
									)
								} else { 
									// If empty label, create empty div for formatting purposes
									stringTypeData.push(
										<div
												className={`${css.rowData} ${css[`rowData_${i}`]} rowData rowData_${i}`}
												style={lineCss}
												data-key={`button_${i}_${rowUUID}`}
												key={`button_${i}_${rowUUID}`}
											>
										</div>
									)
								}
							break;
							case 'Teams':
								if (formattedData.label) {
									stringTypeData.push(
										<div
											className={`${css.rowData} ${css[`rowData_${i}`]} rowData rowData_${i} ${css.msgBtnCont} msgBtnCont`}
											style={lineCss}
											data-key={`button_${i}_${rowUUID}`}
											key={`button_${i}_${rowUUID}`}
										>
										<button
											className={`${css.rowData} rowData_${i} ${css.msgBtn} msgBtn`}
											onMouseDown={(event) => event.stopPropagation()}
											onMouseUp={(event) => event.stopPropagation()}
											onTouchStart={(event) => event.stopPropagation()}
											onTouchEnd={(event) => event.stopPropagation()}
											onClick={(event) => {
												event.stopPropagation();
												this.sendMessage(formattedData, 'teams');
											}}>
											{formattedData.label}
										</button>
										</div>
									)
								} else { 
									// If empty label, create empty div for formatting purposes
									stringTypeData.push(
										<div
												className={`${css.rowData} ${css[`rowData_${i}`]} rowData rowData_${i}`}
												style={lineCss}
												data-key={`button_${i}_${rowUUID}`}
												key={`button_${i}_${rowUUID}`}
											>
										</div>
									)
								}
							break;
							case 'Slack':
								if (formattedData.label) {
									stringTypeData.push(
										<div
											className={`${css.rowData} ${css[`rowData_${i}`]} rowData rowData_${i} ${css.msgBtnCont} msgBtnCont`}
											style={lineCss}
											data-key={`button_${i}_${rowUUID}`}
											key={`button_${i}_${rowUUID}`}
										>
										<button
											className={`${css.rowData} rowData_${i} ${css.msgBtn} msgBtn`}
											onMouseDown={(event) => event.stopPropagation()}
											onMouseUp={(event) => event.stopPropagation()}
											onTouchStart={(event) => event.stopPropagation()}
											onTouchEnd={(event) => event.stopPropagation()}
											onClick={(event) => {
												event.stopPropagation();
												this.sendMessage(formattedData, 'slack');
											}}>
											{formattedData.label}
										</button>
										</div>
									)
								} else { 
									// If empty label, create empty div for formatting purposes
									stringTypeData.push(
										<div
												className={`${css.rowData} ${css[`rowData_${i}`]} rowData rowData_${i}`}
												style={lineCss}
												data-key={`button_${i}_${rowUUID}`}
												key={`button_${i}_${rowUUID}`}
											>
										</div>
									)
								}
							break;
							default:
								// Add MAP button for Wayfinding Modal (8) and Direct WF Modal (14)
								if (isWayfindingModalAction(currentDetailAction) && i === this.props.data.length - 1) {
									stringTypeData.push(
										<div
											className={` ${css.mapBtnCont} mapBtnCont`}
							
										>
											<button
												className={`${css.rowData} rowData_${i} ${css.mapBtn} mapBtn`}
												onMouseDown={(event) => event.stopPropagation()}
												onMouseUp={(event) => event.stopPropagation()}
												onTouchStart={(event) => event.stopPropagation()}
												onTouchEnd={(event) => event.stopPropagation()}
												onClick={(event) => {
													event.stopPropagation();
													this.handleMapClick();
												}}>
												MAP
											</button>
										</div>
									);
								}
								
								stringTypeData.push(
									<div
										className={`${css.rowData} ${css[`rowData_${i}`]} rowData rowData_${i}`}
										style={lineCss}
										data-key={`row_${i}_${rowUUID}`}
										{...(formattedData != null ? { 'data-value': formattedData } : {})}
										key={`row_${i}_${rowUUID}`}
									>
										{formattedData}
										{this.trayDetails()}
									</div>
								);
								break;
						}
					}
				
			} else {
				let lineCss = {
					width: 'auto'
				}
				let headerLabel = '';
				if (this.props.headerAsLabel[i] && this.props.headerData[i].length > 0) {
					headerLabel = this.props.headerData[i] + ': ';
				}

				// Only build the <img> when the listing actually has an image value —
				// "no image configured" is a normal content state. An empty src never
				// queues a request, so the onError cleanup below can't fire and the
				// dead <img> would stay in the DOM (DEV-12094).
				if (data.displayName === 'Image' && formattedData && String(formattedData).trim()) {
					let imageHtml = (<div
							className={`${css.rowData} ${css[`rowData_${i}`]} rowData_${i} ${css.boxImage} boxImage`}
							style={lineCss}
							data-key={`row_${i}_${rowUUID}`}
							key={`row_${i}_${rowUUID}`}
						>
							<img
								src={formattedData}
								className={`${css.detailsData} detailsData ${`imgDetailsData_${i}`} imgDetailsData_${i}`}
								key={`${data.label}_${i}`}
								onError={(e) => {
									e.target.onerror = null;
									e.target.remove();
								}}
							/>
						</div>);

					imageTypeData.push(imageHtml);
					
					if (Array.isArray(this.props.listingLogo) && this.props.listingLogo[i] === true) {
						boxListingImageData.push(imageHtml);
					} // Set listingLogo to true if an image is present
				} else if (data.displayName === 'Image') {
					// Image field with no image set — render nothing for it.
					return;
				} else if (data.displayName === 'SMS Message'|| data.displayName === 'Email Message') {
					// Todo add Virtual concierge to box listings, skips data type if present
					return;
				} else if (data.displayName === 'Text Large') {
					const markdown = converter.makeHtml(formattedData);
					stringTypeData.push(
						<div
							className={`${css.rowData} ${css[`rowData_${i}`]} rowData_${i} ${css.boxStringData} listingRowTextLarge`}
							dangerouslySetInnerHTML={{ __html: markdown }}
							style={lineCss}
							data-key={`row_${i}_${rowUUID}`}
							key={`row_${i}_${rowUUID}`}
						/>
					)
				} else {
					stringTypeData.push(
						<div
							className={`${css.rowData} ${css[`rowData_${i}`]} ${css.boxStringData} ${css[`boxStringData_${i}`]}  boxStringData rowData_${i} boxStringData_${i}`}
							style={lineCss}
							data-key={`row_${i}_${rowUUID}`}
							{...(formattedData != null ? { 'data-value': formattedData } : {})}
							key={`row_${i}_${rowUUID}`}
						>
							{headerLabel}
							{formattedData}
							{this.trayDetails()}
						</div>
					);
				}
			}
		});

		return (
			<>
				{this.props.boxStyleDisplay ? (
					<>
						{(boxListingImageData.length > 0) ? (
							<div className={`${css.boxColumn} ${css.imageColumn} boxColumn imageColumn`}>{boxListingImageData}</div>
						) : (
							<div className={`${css.boxColumn} ${css.imageColumn} boxColumn imageColumn`}>{imageTypeData}</div>
						)}
						<div className={`${css.boxColumn} ${css.textColumn} boxColumn textColumn`}>{stringTypeData}</div>
						{this.props.boxActiveLayout !== 2 ? (
							<div className={`${css.iconColumn} iconColumn`} key={`icon_${rowUUID}`}>
								<div className={rowIconClasses} />
								{isWayfindingModalAction(currentDetailAction) && (
									<button
										className={`${css.mapBtn} mapBtn`}
										onMouseDown={(event) => event.stopPropagation()}
										onMouseUp={(event) => event.stopPropagation()}
										onTouchStart={(event) => event.stopPropagation()}
										onTouchEnd={(event) => event.stopPropagation()}
										onClick={(event) => {
											event.stopPropagation();
											this.handleMapClick();
										}}>
										MAP
									</button>
								)}
							</div>
						) : <></>}
					</>
				) : (
					<>
						{stringTypeData}
						{this.props.currentDetailAction !== 0 && (
							<div className={rowIconClasses} key={`icon_${rowUUID}`} />
						)}
					</>
				)}
			</>
		);
	};

	handleRowClick = (event, msg) => {
		// React 19 fix: stopPropagation is now called in onClick handler synchronously
		if (event && typeof event.stopPropagation === 'function') {
			event.stopPropagation();
		}
		
		this.props.navEvents('idleTimer', '||| ListingsRow.js > handleRowClick()');
		this.props.navEvents('setHasNavigatedListings', true);

		if (this.props.currentDetailAction === 4 || this.props.currentDetailAction === 6 || this.props.currentDetailAction === 7 || this.props.currentDetailAction === 8) {
			this.props.setDetailsData(this.props.data, this.props.rowUUID, this.props.detailsGrp, this.props.currentDetailAction);

			if (typeof (this.props.addToHistory) === 'function') {
				this.props.addToHistory();
			}

			if (this.props.detailsTitle) {
				this.props.setDetailsTitle(this.props.detailsTitle.value);
			}
		}

		if (this.props.currentDetailAction === 5) {
			let dataArray = this.props.data;
			//loop through this.props.detailsGrp
			let imageItem = this.props.detailsGrp.find(item => item.type === 'Image');
			if (imageItem) {
				dataArray.push(imageItem.value);
			}
			this.props.setDetailsData(dataArray, this.props.rowUUID, this.props.detailsGrp, this.props.currentDetailAction);

			if (this.props.detailsTitle) {
				this.props.setDetailsTitle(this.props.detailsTitle);
			}
			if (typeof (this.props.addToHistory) === 'function') {
				this.props.addToHistory();
			}
		}

		if (this.props.currentDetailAction === 10) { // tier+1
			if (typeof (this.props.displayChildTier) === 'function') {
				this.props.displayChildTier(this.props.rowUUID, [], undefined, this.props.data[0], true, this.props.openWayfindingModal);
			}
		}

		if (this.props.currentDetailAction === 11 ) { //iframe URL
			this.props.setDetailsData(this.props.data, this.props.rowUUID, this.props.detailsGrp, this.props.currentDetailAction);
			
			if(this.props.detailsTitle){
				this.props.setDetailsTitle(this.props.detailsTitle);
			}

			if(typeof(this.props.addToHistory) === 'function') {
				this.props.addToHistory();
			}
		} 
		

		if (this.props.currentDetailAction === 12 ) { //PDF Touch action
			this.props.setDetailsData(this.props.data, this.props.rowUUID, this.props.detailsGrp, this.props.currentDetailAction);
			
			if(this.props.detailsTitle){
				this.props.setDetailsTitle(this.props.detailsTitle);
			}
		
			if(typeof(this.props.addToHistory) === 'function') {
				this.props.addToHistory();
			}
		}

		if (this.props.currentDetailAction === 13 ) { //Video Touch action
			this.props.setDetailsData(this.props.data, this.props.rowUUID, this.props.detailsGrp, this.props.currentDetailAction);
			
			if(this.props.detailsTitle){
				this.props.setDetailsTitle(this.props.detailsTitle);
			}
		
			if(typeof(this.props.addToHistory) === 'function') {
				this.props.addToHistory();
			}
		}  

		if (this.props.currentDetailAction === TOUCH_ACTION_DIRECT_WAYFINDING) { // Direct WF Modal (DEV-12130)
			// The whole row behaves like the MAP button: no details page, no history entry.
			this.openWayfindingModalForRow();
		}

		dlRowClick({
			rowData: (this.props.data.map((entry) => { return entry.value; }) || []).join(' | '),
			headerData: (this.props.headerData || []).join(' | '),
			listName: this.props.defaultListName,
			listing: this.props.rowUUID,
			searchTerm: this.props.searchInputValue || '',
			tier: this.props.tier,
		});
	}

	messageActive = ({ message, onClose }) => {
        let css = this.state.css
        return (
          <div className={`${css.messageRow}`} onClick={onClose}>
              <p>{message}</p>
          </div>
        );
      };

	handleMessageClick = () => {
        if (this.state.timeoutId) {
            clearTimeout(this.state.timeoutId);
        }

        const timeoutId = setTimeout(() => {
            this.setState({
                showMessageText: false,
                timeoutId: null,
                messageText: "Sending..."
            });
        }, 5000);

        // React 19 fix: Combine setState calls for better performance
        this.setState({
            showMessageText: true,
            timeoutId
        });
    };

	handleMapClick = () => {
		// Local repeat guard, NOT the global btnDebouncer: buttonActive stays set
		// for 600ms after any debounced button, so the global gate silently
		// swallows a MAP tap that follows a nav tap (caught by @condor29). The
		// desync itself is fixed by the explicit openMapModal event; this guard
		// only stops a double-tap running the open side effects twice (DEV-12143).
		// Scoped to rowUUID: parents key rows by index, so a reused instance may
		// now be showing a different listing, whose first tap is not a repeat.
		const now = Date.now();
		if (this.lastMapClickUUID === this.props.rowUUID && now - (this.lastMapClickTs || 0) < 500) {
			return;
		}
		this.lastMapClickTs = now;
		this.lastMapClickUUID = this.props.rowUUID;

		this.props.navEvents('idleTimer', '||| ListingRow.js > handleMapClick()');
		this.openWayfindingModalForRow();
	};

	// Shared by the MAP button (actions 8 and 14) and the whole-row tap (action 14):
	// stage the row's details WITHOUT opening the details page, then open the modal.
	openWayfindingModalForRow = () => {
		const openDetails = false;
		this.props.setDetailsData(this.props.data, this.props.rowUUID, this.props.detailsGrp, this.props.currentDetailAction, openDetails);

		if (typeof this.props.openWayfindingModal === 'function') {
			this.props.openWayfindingModal(this.props.rowUUID, this.props.detailsGrp);
		}
	};

    handleMessageClose = () => {
        if (this.state.timeoutId) {
            clearTimeout(this.state.timeoutId);
        }
        this.setState({ showMessageText: false, messageText: "Sending..." })
    };

	render() {
		let { css, activeButton } = this.state;
		let { currentDetailAction, rowUUID } = this.props;

		let activeButtonClass = activeButton === rowUUID ? `${css.activeButton} activeButton` : '';
		let currentDetailActionClass = '';

		if (currentDetailAction === 0) {
			activeButtonClass =  "";
			currentDetailActionClass = css.noDetailsRow
		}

		// Map button class for Wayfinding Modal (8) and Direct WF Modal (14); the extra
		// listingRowDirectWFModal class lets a theme hide .mapBtn for 14 only (DEV-12130)
		let mapBtnClass = isWayfindingModalAction(currentDetailAction) ? `${css.listingRowMapBtn} listingRowMapBtn` : '';
		if (currentDetailAction === TOUCH_ACTION_DIRECT_WAYFINDING) {
			mapBtnClass += ' listingRowDirectWFModal';
		}
		
		let rowClass = `${css.listingLine} listingLine ${currentDetailActionClass} ${activeButtonClass} ${mapBtnClass}`;
		if (this.props.boxStyleDisplay) {
			rowClass = `${css.listingBox} listingBox ${css[`boxLayout${this.props.boxActiveLayout}`]} boxLayout${this.props.boxActiveLayout} ${css[`cols${this.props.boxColumnsPerRow}`]} ${currentDetailActionClass} ${activeButtonClass} ${mapBtnClass}`
		}

		return (
			<div
				className={rowClass}
				data-name={rowUUID}
				key={rowUUID}
				onClick={(event) => {
					// React 19 fix: stopPropagation must be called synchronously
					event.stopPropagation();
					this.props.navEvents('btnDebouncer', () => this.handleRowClick(null, '[onClick]'));
				}}
				onMouseDown={(event) => {
					this.mouseStartY = event.clientY;
					this.handleDown(rowUUID, '[onMouseDown]');
				}}
				onMouseUp={(event) => {
					this.handleUp('[onMouseUp]');
					const mouseDelta = Math.abs(event.clientY - this.mouseStartY);
					if (mouseDelta < 10) {
						this.props.navEvents('btnDebouncer', () => this.handleRowClick(null, '[onMouseUp]'));
					}
				}}
				onMouseLeave={() => this.handleUp('[onMouseLeave]')}
				onTouchStart={(event) => {
					this.touchStartY = event.touches[0].clientY;
					this.handleDown(rowUUID, '[onTouchStart]');
				}}
				onTouchEnd={(event) => {
					this.handleUp('[onTouchEnd]');
					const touchEndY = event.changedTouches[0].clientY;
					const touchDelta = Math.abs(touchEndY - this.touchStartY);
					if (touchDelta < 10) {
						event.preventDefault();
						this.props.navEvents('btnDebouncer', () => this.handleRowClick(null, '[onTouchEnd]'));
					}
				}}
				onPointerDown={() => { 
					this.handleDown(rowUUID, '[onPointerDown]');
				}}
				onPointerUp={() => this.handleUp('[onPointerUp]')}
				onPointerLeave={() => this.handleUp('[onPointerLeave]')}
			>
				{this.state.showMessageText ? this.messageActive({ message: this.state.messageText, onClose: this.handleMessageClose }) : this.createData()}
			</div>
		);

	}
}

export default ListingRow
